export default "__VITE_ASSET__fc7ba351__"